var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Preview"}},[_c('iframe',{attrs:{"sandbox":"","src":_vm.bodyBlob}})])
}
var staticRenderFns = []

export { render, staticRenderFns }